











import { Component, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import { parsePhoneNumberFromString, AsYouType, CountryCode, PhoneNumber } from 'libphonenumber-js'
import AutoMixin from '@/mixins/auto'

/**
 * See for more details on parsing phone numbers.
 * https://github.com/catamphetamine/libphonenumber-js
 */
@Component
export default class Phone extends Mixins(AutoMixin) {
  localNumber: string = ''

  @Prop({ type: String })
  id!: string

  @Prop({ type: Object })
  value?: PhoneNumber | string

  @Prop({ type: String, default: '' })
  name!: string

  @Prop({ type: Boolean, default: false })
  required!: boolean

  @Prop({ type: String, default: '' })
  placeholder!: string

  @Prop({ type: [String, Boolean], default: null })
  state!: string | boolean | null

  @Prop({ type: String })
  defaultCountryCode?: CountryCode

  get AsYouType () {
    return new AsYouType(this.defaultCountryCode)
  }

  inputHandler (value: string) {
    this.AsYouType.reset()
    this.localNumber = this.AsYouType.input(value)
    return this.AsYouType.getNumber()
  }

  @Emit('change')
  changeHandler (value: string) {
    return this.AsYouType.getNumber()
  }

  @Watch('value', { immediate: true })
  valueChanged (newValue?: PhoneNumber | string) {
    if (newValue == null || typeof newValue === "string")
      return this.localNumber = newValue || ""

    this.localNumber = newValue.country === this.defaultCountryCode
      ? newValue.formatNational()
      : newValue.number.toString()
  }
}
